import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { DiscountReasonsListResponseData } from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const DISCOUNT_REASONS_LIST_QUERY_KEY = 'discount_reasons_list';

// Option lists (e.g. the sale-dialog discount modal) need every reason at once.
const DISCOUNT_REASONS_PAGE_SIZE = 1000;

export const useDiscountReasonsListQuery = (url: string) =>
  useQuery({
    queryKey: [DISCOUNT_REASONS_LIST_QUERY_KEY, url],
    queryFn: () =>
      HttpClient.request<DiscountReasonsListResponseData>({
        method: 'GET',
        url,
        params: { size_per_page: DISCOUNT_REASONS_PAGE_SIZE },
      }),
    enabled: !!url,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
